import { render, staticRenderFns } from "./PeopleSearch.vue?vue&type=template&id=1afa1f69&scoped=true&"
import script from "./PeopleSearch.vue?vue&type=script&lang=js&"
export * from "./PeopleSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afa1f69",
  null
  
)

export default component.exports